import React, { Component } from 'react';
import PropTypes from 'prop-types';
import trustpilotLoader from '../../../util/trustpilot';

/**
 * Reusable Trustpilot Widget Component
 * 
 * Usage:
 * <TrustpilotWidget
 *   templateId="5419b6a8b0d04a076446a9ad"
 *   businessunitId="Y48fbe7ac000064000503d248"
 *   height="20px"
 *   width="100%"
 *   theme="light"
 *   stars="4,5"
 *   locale="en-US"
 * />
 */
class TrustpilotWidget extends Component {
    constructor(props) {
        super(props);
        this.widgetRef = React.createRef();
    }

    componentDidMount() {
        this.initializeWidget();
    }

    componentDidUpdate(prevProps) {
        // Reinitialize if key props changed
        const keyProps = ['templateId', 'businessunitId', 'theme', 'stars', 'dataToken'];
        const hasChanged = keyProps.some(prop => prevProps[prop] !== this.props[prop]);
        
        if (hasChanged) {
            this.reinitializeWidget();
        }
    }

    initializeWidget() {
        if (this.widgetRef.current) {
            trustpilotLoader.loadAndInitialize(this.widgetRef.current.parentElement);
        }
    }

    reinitializeWidget() {
        if (this.widgetRef.current) {
            // Reset initialization flag
            delete this.widgetRef.current.dataset.initialized;
            this.initializeWidget();
        }
    }

    render() {
        const {
            templateId,
            businessunitId,
            height = '24px',
            width = '100%',
            theme = 'light',
            stars,
            locale = 'en-US',
            className = '',
            style = {},
            trustpilotUrl,
            dataToken
        } = this.props;

        const widgetProps = {
            'data-locale': locale,
            'data-template-id': templateId,
            'data-businessunit-id': businessunitId,
            'data-style-height': height,
            'data-style-width': width,
            'data-theme': theme
        };

        if (stars) {
            widgetProps['data-stars'] = stars;
        }

        if (dataToken) {
            widgetProps['data-token'] = dataToken;
        }

        return (
            <div
                ref={this.widgetRef}
                className={`trustpilot-widget ${className}`}
                style={style}
                {...widgetProps}
            >
                {trustpilotUrl && (
                    <a href={trustpilotUrl} target="_blank" rel="noopener noreferrer">
                        Trustpilot
                    </a>
                )}
            </div>
        );
    }
}

TrustpilotWidget.propTypes = {
    templateId: PropTypes.string.isRequired,
    businessunitId: PropTypes.string.isRequired,
    height: PropTypes.string,
    width: PropTypes.string,
    theme: PropTypes.oneOf(['light', 'dark']),
    stars: PropTypes.string,
    locale: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    trustpilotUrl: PropTypes.string,
    dataToken: PropTypes.string
};

export default TrustpilotWidget;
